import { useState, useEffect, useContext } from "react";
import { UserContext } from "../../../context/UserContext";
import { Rest } from "../../../util/rest";

export function useIqolData(assignmentId) {
  const { user } = useContext(UserContext);

  const [iqol, setIqol] = useState(null);
  const [burnout, setBurnout] = useState(null);
  const [lifestyles, setLifestyles] = useState(null);
  const [burnoutII, setBurnoutII] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!assignmentId) return;

    const fetchData = async () => {
      try {
        const [iqol, burnout, lifestyles, burnoutII] = await Promise.all([
          Rest.authFetch(user, `/rest/assignment/${assignmentId}/results/iqol/habits`),
          Rest.authFetch(user, `/rest/assignment/${assignmentId}/results/iqol/burnout`),
          Rest.authFetch(user, `/rest/assignment/${assignmentId}/results/iqol/lifestyles`),
          Rest.authFetch(user, `/rest/assignment/${assignmentId}/results/iqol/burnoutII`),
        ]);
        setIqol(iqol);
        setBurnout(burnout);
        setLifestyles(lifestyles);
        setBurnoutII(burnoutII);
      } catch (e) {
        setError(e);
      }
    };

    fetchData();
  }, [assignmentId, user]);

  return { iqol, burnout, lifestyles, burnoutII, error };
}
